import { Contact } from './contact.model';

export class PropertyGroup {
  id: string;
  manager: Contact;
  owner: Contact;
}
